import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { getAllDatabasesByProject } from '../../actions/dbActions';
import Message from '../../utils/Message';
import Loader from '../../utils/Loader';
import { CSVLink } from 'react-csv';
import UpdateDbEditTable from '../../components/UpdateDbEditTable';
import Swal from 'sweetalert2';

const DatabaseEditTable = ({ report, projectId }) => {
	const dispatch = useDispatch();
	const [rowsData, setRowsData] = useState({ columns: [], rows: [] });
	const [csvData, setCsvData] = useState([]);
	const [filter, setFilter] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [modal, setModal] = useState(false);
	const [currentReportRowData, setCurrentReportRowData] = useState('');

	const [resData, setResData] = useState('');
	const [queryFields, setQueryFields] = useState([]);
	const [selectedDb, setSelectedDb] = useState('');
	const [updated, setUpdated] = useState(false);
	const [loadingClient, setLoadingClient] = useState(false);

	const [currentDatabase, setCurrentDatabase] = useState('');
	const user = JSON.parse(localStorage.getItem('centralize-admin-data'));
	const { databases, loading, error } = useSelector((store) => store.databaseR);
	// const baseUrl = 'http://localhost:5005/api/v2/admin/userReport';

	const today = new Date();
	const csvDate = `${today.getFullYear()}_${today.getMonth() + 1}_${today.getDate()}`;

	useEffect(() => {
		if (projectId) {
			dispatch(getAllDatabasesByProject(projectId));
		}
	}, [projectId, dispatch]);

	useEffect(() => {
		if (!filter) return;
		if (filter || queryFields || updated) {
			const user = JSON.parse(localStorage.getItem('centralize-admin-data'));
			let newArr = {};
			queryFields.forEach((e) => {
				if (!e.value) return;
				newArr[e.field] = e.value;
			});

			const query = {
				tableName: selectedDb,
				token: user.accessToken,
				query: newArr,
			};
			setLoadingClient(true);
			axios
				.post(currentDatabase.queryEndpoint, query)
				.then((data) => {
					if (data.data) {
						setResData(data.data.data);
						setLoadingClient(false);
						setErrorMsg('');
					}
				})
				.catch((err) => {
					setErrorMsg(err.response ? err.response.data.error : '');
					setLoadingClient(false);
				});
		}
	}, [filter, queryFields, updated, selectedDb, currentDatabase.queryEndpoint]);

	function toggle() {
		setModal(!modal);
	}

	function closeModal() {
		setModal(false);
		setUpdated(true);
	}

	function getReport(curReport) {
		setCurrentReportRowData(curReport);
		setModal(true);
		setUpdated(false);
	}

	const deleteData = (data) => {
		Swal.fire({
			title: 'Are you sure?',
			text: `You want to delete this!`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
		}).then((result) => {
			if (result.isConfirmed) {
				let newData = {};
				newData.id = data._id;
				newData.token = user.accessToken;
				newData.tableName = selectedDb;
				// console.log('newData', newData);
				axios
					.post(currentDatabase.deleteEndpoint, newData)
					.then((data) => {
						Swal.fire('Deleted!', 'success');
						setUpdated(true);
					})
					.catch((err) => Swal.fire('Server Error', 'error'));
			}
		});
	};

	useEffect(() => {
		if (resData && currentDatabase && filter) {
			let data = {
				// capture according to editable fields
				columns: currentDatabase.tableHeader.length ? currentDatabase.tableHeader : [],
			};
			const newD = resData.map((each) => {
				let data = { ...each };
				let newArr = {};

				currentDatabase.tableHeader.forEach((e) => {
					let str = e.field.split('.');
					const length1 = str.length === 1 ? data[str[0]] : '';
					const length2 = str.length === 2 && data[str[0]] ? data[str[0]][str[1]] : '';
					const length3 = str.length === 3 && data[str[0]][str[1]] ? data[str[0]][str[1]][str[2]] : '';
					const length4 = str.length === 4 && data[str[0]][str[1]][str[2]] ? data[str[0]][str[1]][str[2]][str[3]] : '';

					newArr[e.field] = str.length === 1 ? length1 : str.length === 2 ? length2 : str.length === 3 ? length3 : length4;
				});
				newArr.id = (
					<div style={{ cursor: 'pointer' }}>
						<i onClick={() => getReport(each)} className='far fa-edit '></i>{' '}
						{currentDatabase.deletable ? <i onClick={() => deleteData(each)} className='fas fa-trash  text-danger mx-3'></i> : null}
					</div>
				);
				return newArr;
			});

			data.rows = newD ? newD : [];
			setRowsData({ columns: data.columns, rows: data.rows });
			//
			data.rows && setCsvData(data.rows);
		}
	}, [resData, currentDatabase, filter]);

	function queryObjectChange(e, index) {
		setFilter(false);
		let newArr = [...queryFields];
		const { value } = e.target;
		newArr[index].value = value;
		setQueryFields(newArr);
	}

	function getCurrentDb(dbName) {
		if (!dbName) {
			return setSelectedDb('');
		}
		setUpdated(false);
		setFilter(false);
		setSelectedDb(dbName);
		const cur = databases.find((e) => e.tableName === dbName);
		setCurrentDatabase(cur);
		setQueryFields(cur.searchBy);
	}

	function resetInput() {
		const newArr = [];
		currentDatabase.searchBy.forEach((e) => {
			e.value = '';
			newArr.push(e);
		});
		setQueryFields(newArr);
	}
	// console.log('resData', resData);
	// console.log('queryFields', queryFields);
	// console.log('currentDatabase', currentDatabase);
	// console.log('report', report);
	return (
		<div>
			{loading || loadingClient ? (
				<Loader />
			) : error ? (
				<Message color='danger'> {error} </Message>
			) : (
				<>
					{errorMsg ? <Message color='danger'> {errorMsg} </Message> : null}
					<div className='card'>
						<div className='card-header d-flex justify-content-between align-items-center'>
							<div>
								<h5 className='text-capitalize'> Database Edit</h5>
							</div>
						</div>

						<UpdateDbEditTable
							modal={modal}
							toggle={toggle}
							currentReportRowData={currentReportRowData}
							projectId={projectId}
							table={selectedDb}
							accessToken={user.accessToken}
							database={currentDatabase}
							errorMsg={errorMsg}
							setErrorMsg={setErrorMsg}
							closeModal={closeModal}
						/>

						<div className='d-flex flex-wrap mt-3'>
							<div className='mx-3'>
								<label> Select Database </label>
								<select type='select' name='table' className='form-select mr-3' value={selectedDb} onChange={(e) => getCurrentDb(e.target.value)}>
									<option value=''>Select Database </option>
									{databases &&
										databases.map((e, i) => {
											return <option key={i}>{e.tableName}</option>;
										})}
								</select>
							</div>

							<div className='d-flex flex-wrap'>
								{queryFields.length
									? queryFields.map((query, i) => {
											return (
												<div key={i}>
													{query.type === 'dropdown' ? (
														<div className='mx-3 '>
															<label> {query.label} </label>
															<select
																type='select'
																name={query.field}
																className='form-select mr-3'
																value={query.value}
																onChange={(e) => queryObjectChange(e, i)}>
																<option value=''>Select</option>
																{query.dropdown.map((e, i) => {
																	return <option key={i}>{e}</option>;
																})}
															</select>
														</div>
													) : (
														<div className='mx-3'>
															<label> {query.label} </label>
															<input
																type={query.type === 'date' ? 'date' : query.type === 'number' ? 'number' : 'text'}
																name={query.field}
																className='form-select mr-3'
																value={query.value}
																placeholder={query.label}
																onChange={(e) => queryObjectChange(e, i)}></input>
														</div>
													)}
												</div>
											);
									  })
									: null}
							</div>

							<div className='mt-3'>
								<button onClick={() => setFilter(true)} className='btn btn-dark'>
									Filter
								</button>
								<button onClick={() => resetInput()} className='btn btn-dark'>
									Reset
								</button>
							</div>
						</div>

						<div>{!resData.length && filter ? <Message color='warning'> No data to show </Message> : null}</div>

						<div className='card-body text-center'>
							<MDBDataTable data={rowsData} bordered noBottomColumns small responsive hover />
						</div>
						{csvData && (
							<>
								<div className='card-footer'>
									<CSVLink
										// headers={userHeadersSingleCSV}
										data={csvData && csvData}
										filename={`${selectedDb}-${csvDate}.csv`}
										className='btn btn-outline-secondary'>
										Download as CSV
									</CSVLink>
								</div>
							</>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default DatabaseEditTable;
